<template>
    <div class="text-center">
        <v-dialog persistent v-model="visible" width="700">
            <v-card class="not-margin pt-0 pr-0 pl-0">
            <v-toolbar dark color="primary">
                <div class="text-center">
                    {{ isView ? " Detalhar Reprovação":" Reprovar Formação"}}
                </div>
            </v-toolbar>
            <div class="container dialog">
            <v-form ref="form" v-if="visible">
                <v-row class="d-flex justify-center mt-2">
                    <v-col cols="12" class="d-block">
                        <label for="justificativa"
                            style="line-height:1rem;font-weight: 500"
                            > {{ isView ? "Justificativa":"Justificativa de reprovação*"}}
                        </label>
                        <v-textarea
                            v-model="form.justificativaReprovacao"
                            id="justificativa"
                            :counter="!isView ? 400 : false"
                            maxlength="400"
                            outlined
                            dense
                            :disabled="isView"
                            :rules="[$required]"
                        />
                    </v-col>
                </v-row>
                <small v-if="isView" class="font-weight-bold d-block" style="margin-top: -2rem;" >Reprovado por: {{ content?.justificativaReprovacao?.usuario}} em {{ content?.justificativaReprovacao?.data }}</small>
            </v-form>
            </div>
            <sigfoco-buttons
                v-if="!isView"
                @click="reprovar()"
                @cancel="$emit('onClose')"
                :actionText="'Reprovar'"
            ></sigfoco-buttons>
            <div class="btn-group text-center" v-else>
            <v-btn color="primary" outlined @click="$emit('onClose')">
                Fechar
            </v-btn>
            </div>
        </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Formacao } from '~/commons/classes/formacao';
import ManterFormacaoService from '~/services/manter-formacao.service';

export default {
    props: new DialogProps(Formacao),
    mixins: [ManterFormacaoService],
    data: () => ({
        isView: false,
        form: {
            justificativaReprovacao: ''
        }
    }),
    methods: {
        reprovar() {
            if(!this.$refs.form.validate()){
                return this.$notifyWarning("Preencha todos os campos obrigatórios!");
            }
            this.confirmacaoModal();
        },
        confirmacaoModal() {
            this.$swal({
                text: `Deseja reprovar a Solicitação de Formação?`,
                type: "error",
                showCancelButton: true,
                confirmButtonText: `Confirmar`,
                cancelButtonText: `Cancelar`,
            }).then(() => {
                this.$justificativaReprovacao(
                    { 
                        formacaoId: this.content.id,
                        justificativa : this.form.justificativaReprovacao,
                        tipoReprovacao: this.content?.tipoReprovacao
                    },
                this.content.id
                ).then(({ data }) => {
                    this.$notifySuccess(data.mensagem);
                    this.$emit('onReprove', this.content);
                    this.$emit('onClose', this.content);
                });
            }).catch(() => {
                this.$emit('onClose', this.content);
            });
        },
    },
    mounted() {
        this.isView = this.edit;
        if(this.content?.justificativaReprovacao?.justificativa){
            this.form.justificativaReprovacao = this.content?.justificativaReprovacao?.justificativa;
        }
    }
};
</script>